export default {
  swapOfferCardGuidance: {
    id: 'buyback_swap_offer_card_guidance',
    defaultMessage:
      "Next, you'll get paid once your item is received and checked.",
  },
}
